import { render, staticRenderFns } from "./ListUserIntegrationSettingsContacts.vue?vue&type=template&id=479f387e&scoped=true&"
import script from "./ListUserIntegrationSettingsContacts.vue?vue&type=script&lang=js&"
export * from "./ListUserIntegrationSettingsContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479f387e",
  null
  
)

export default component.exports